export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";